import qs from 'query-string';

export function parseRawQueryString(url: string) {
  return qs.parseUrl(url);
}
